export class MeasurementsUnit {

    Id: number;
    FacilityId: number;
    Title: string;
    ForeignTitle: string;

    constructor() { }
}